import {
    ComposerAttributeNode,
    ComposerAttributeOptionNode,
    ComposerOptionActionNode
} from '../../../configurator-components/composer-editors/attributes/composerAttributesModels';
import { setActionSceneElementType } from './composerHelpers';
import {
    ComposerValidationContext,
    validateComposerActions,
    validateComposerAttributes,
    validateComposerOptions
} from './composerAttributeValidation';

export const LazyValidateAttributes = async (
    attributeList: ComposerAttributeNode[],
    context: ComposerValidationContext = {}
): Promise<ComposerAttributeNode[]> => {
    await Promise.all(attributeList.flatMap((attribute) => attribute.options.map((option) => LazyValidateActions(option.actions))));
    return validateComposerAttributes(attributeList, context);
};

export const LazyValidateOptions = async (
    attribute: ComposerAttributeNode,
    optionList: ComposerAttributeOptionNode[],
    allNodes: ComposerAttributeNode[] = [attribute],
    context: ComposerValidationContext = {}
): Promise<ComposerAttributeOptionNode[]> => {
    await Promise.all(optionList.map((option) => LazyValidateActions(option.actions)));
    return validateComposerOptions(attribute, optionList, allNodes, context);
};

export const LazyValidateActions = async (actionList: ComposerOptionActionNode[]): Promise<ComposerOptionActionNode[]> => {
    return new Promise<ComposerOptionActionNode[]>((resolve) => {
        actionList.forEach((action) => {
            // fix wrong scene action types
            setActionSceneElementType(action);
        });
        resolve(validateComposerActions(actionList));
    });
};
